var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGalleryHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGalleryHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-706.000000, -2006.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "On-the-ground",
    transform: "translate(27.000000, 1823.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-gallery",
    transform: "translate(9.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54938602,11.563401 C2.54938602,13.1667272 3.86968748,14.4870286 5.47265315,14.4866681 L12.5652174,14.4866681 L12.5652174,15.5394481 C12.5652174,16.3470601 11.9025429,17 11.0956519,17 L1.45730707,17 C0.650055578,17 -1.58983937e-13,16.3470601 -1.58983937e-13,15.5394481 L-1.58983937e-13,5.90146375 C-1.58983937e-13,5.09493334 0.650055578,4.43478261 1.45730707,4.43478261 L2.54938602,4.43478261 L2.54938602,11.563401 Z M15.5394481,6.83897383e-14 C16.3459785,6.83897383e-14 17,0.653300448 17,1.46091248 L17,11.0988968 C17,11.9068694 16.3459785,12.5652174 15.5394481,12.5652174 L5.90074266,12.5652174 C5.09421226,12.5652174 4.43478261,11.9068694 4.43478261,11.0988968 L4.43478261,1.46055194 C4.43478261,0.653660989 5.09385171,6.83897383e-14 5.90074266,6.83897383e-14 L15.5394481,6.83897383e-14 Z M15.3411505,10.2894821 C15.4211906,10.1416602 15.4136192,9.964274 15.3213207,9.82258135 L13.7965925,7.48915944 C13.6931172,7.33052136 13.5305131,7.22019579 13.3448345,7.1834206 C13.1598769,7.14628487 12.9677085,7.18486276 12.8112337,7.29122238 L11.2901108,8.3241726 C10.9739163,8.53977617 10.5430697,8.46225983 10.3206158,8.14967071 L8.66861658,5.82886774 C8.51286283,5.6100193 8.24606243,5.49825156 7.98070419,5.54151649 C7.71534595,5.58514196 7.49830022,5.77514712 7.42042334,6.03221291 L6.2389302,9.94011774 C6.19710744,10.0796471 6.22342694,10.2281901 6.3099568,10.3450054 C6.39648666,10.4610996 6.53313173,10.525997 6.67842979,10.525997 L14.9373444,10.525997 C15.1060777,10.525997 15.2607498,10.438025 15.3411505,10.2894821 Z",
    id: "icGalleryHS"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGalleryHs);
export default __webpack_public_path__ + "static/media/icGalleryHS.c8d6781a9514c70090b80010262b3d1f.svg";
export { ForwardRef as ReactComponent };